import { Pipe, PipeTransform } from '@angular/core';
import { base64ToDataUrl } from '../utils/base64-data-url';

/**
 * Angular pipe: transforms a raw Base64 image string into a data URL.
 * Defaults to image/jpeg when mime is not provided.
 */
@Pipe({ name: 'base64ToDataUrl' })
export class Base64ToDataUrlPipe implements PipeTransform {
  transform(base64: string | null | undefined, mime: string = 'image/jpeg'): string | null {
    return base64ToDataUrl(base64, mime);
  }
}

